import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  companyTypes: null,
  status: 'idle',
  error: null,
};

const companyTypeSlice = createSlice({
  name: 'companyType',
  initialState,
  reducers: {
    getAllCompanyTypesStart: (state) => {
      state.status = 'loading';
      state.error = null;
    },
    getAllCompanyTypesSuccess: (state, action) => {
      state.status = 'success';
      state.companyTypes = action.payload.data;
      state.error = null;
    },
    getAllCompanyTypesFailure: (state, action) => {
      state.status = 'fail';
      state.error = action.payload.message;
    },
  },
});

export const { getAllCompanyTypesStart, getAllCompanyTypesSuccess, getAllCompanyTypesFailure } =
  companyTypeSlice.actions;

export default companyTypeSlice.reducer;
